import React, { useState, useEffect } from 'react';
import { shopContext } from '../../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import { chatbotApi } from '../../../common/src';
import axios from 'axios';
import moment from 'moment';
import { toast } from 'react-toastify';

const WidgetTimeline = (props) => {
  const { tveeImgUrl, history } = props;
  const [timeList, setTimelist] = useState();
  const param = props.childProps.payload.param;
  const date = props.childProps.payload.date;
  //   //console.log(props.childProps);

  const today = moment(new Date());
  const [value, setValue] = useState(moment(today).format('YYYY-MM-DD'));
  const _day = [];
  _day.push(today);
  for (let i = 1; i < 7; i++) {
    _day.push(moment(today).add(i, 'd'));
  }

  const list = props.childProps.payload.list;
  //   const param = props.childProps.payload.param;
  const preText = props.childProps.state.prevMessage;

  const _prev = () => {
    props.childProps.actionProvider._categoryPrev(preText);
  };
  const _goHome = () => {
    props.childProps.actionProvider._home(-1);
  };
  const _onChange = async (e) => {
    const date = e.target.value;
    //console.log(date);

    const result = await axios.get(
      chatbotApi + '/api/getLiveTimeline?date=' + date
    );
    const intReturn = result.data.intReturn;
    if (intReturn === 0) {
      setValue(date);
      setTimelist(result.data.listData);
    }
  };
  const _more = () => {
    const { setTimeline, setTvline } = props;
    if (param === 'live') {
      setTvline(false);
      setTimeline(true);
    } else if (param === 'tv') {
      setTvline(true);
      setTimeline(false);
    }
  };
  const _goItem = (contentSerial, aniplusVodService) => {
    //console.log(param, aniplusVodService);
    if (param === 'live') {
      history.push('/items/' + contentSerial);
    } else {
      if (aniplusVodService) {
        history.push('/items/' + contentSerial);
      } else {
        toast.warn('VOD 서비스 작품이 아닙니다.');
      }
    }
  };
  useEffect(() => {
    setTimelist(list);
  }, []);

  return (
    <div className="schedule-wrapper">
      <div className="select-wrapper">
        {date ? (
          <div>
            {date} {param === 'live' ? 'LIVE' : ' TV'} 편성표
          </div>
        ) : (
          <select className="custom-select" onChange={_onChange} value={value}>
            {_day.map((item) => (
              <option key={item} value={moment(item).format('YYYY-MM-DD')}>
                {moment(item).format('YYYY-MM-DD')}{' '}
                {moment(item).format('YYYY-MM-DD') ===
                  moment(today).format('YYYY-MM-DD') && ' (오늘)'}
              </option>
            ))}
          </select>
        )}
      </div>
      <div className="program-list">
        {timeList &&
          timeList.map((item) => (
            <div
              className="program-item"
              key={item.contentPartSerial}
              onClick={() =>
                _goItem(item.contentSerial, item.aniplusVodService)
              }
            >
              <div className="time">
                {param === 'live'
                  ? item.outputStart.substring(0, 5)
                  : item.C_startTime}
              </div>
              <div className="title">
                <span className="item-title">{item.title}</span>
                <br />
                <span className="item-subTitle">{item.subTitle}</span>
              </div>
            </div>
          ))}
      </div>

      <div className="prev-chat-container">
        <div className="prev-contaner">
          <div className="prev" onClick={_more}>
            <img src="/img/chatbot/icon_qna.png" />
            편성표 자세히 보기
          </div>

          <div onClick={_goHome} className="prev">
            <img src="/img/chatbot/icon_home.png" />
            처음으로
          </div>
        </div>
      </div>
    </div>
  );
};

export default shopContext(withRouter(WidgetTimeline));
